<template>
    <div class="container">
      <section class="hero is-light  ">
        <div class="hero-body   ">
          <p class="title "  >
            Pathology News
          </p>
          <p class="subtitle mt-1" v-if="modeLabNewsElement == 0">
            {{labNewsElement.title}}
          </p>
            
          <b-input v-if="modeLabNewsElement == 1" v-model="dataToEdit.title"></b-input>


        </div>
      </section>

      <section class="mt-5">


 



  

 
 
      



        
         <div v-html="labNewsElement.descptoin_html"  v-if="modeLabNewsElement == 0"></div>
         <vue-editor v-model="dataToEdit.descptoin_html"  v-if="modeLabNewsElement == 1"  :editor-toolbar="customToolbar"   id="editor1"   />
      </section>  
      

      <!-- images -->
      <section  class="mt-5">
          <ImagesLabNewsListView 
             :imgs = "labNewsElement.imgs"
             :canAddImage = "isCanAddImage"
             @updatedImage="updatedImage"
          />
      </section> 

      <hr v-if="modeLabNewsElement == 1">
      <section  class="mt-5 mb-5" v-if="modeLabNewsElement == 1">
        <b-button type="is-success" @click="updateNews">Update</b-button>     
      </section>   
 

 

    </div>
</template>



<script>

import {  mapState , mapMutations} from "vuex";
import ImagesLabNewsListView from './ImagesLabNewsListView.vue'
import axios from "axios";
import { getBaseURLforBackEnd  , getConfigAxios  }  from '@/utils.js'
import htmlToText from "html-to-text";

 


export default {
    name : "LabNewsDetails",
    mounted(){
        //  console.log('LabNewsDetails mounted',this.modeLabNewsElement);
        if(this.modeLabNewsElement == 1){
          this.dataToEdit = Object.assign({},this.labNewsElement)
        }
    },
    components:{
      ImagesLabNewsListView,
    },
    computed:{
          ...mapState({
            access_token: state => state.master_data.access_token ,
            labNewsElement : state => state.lab_news_element.labNewsElement ,
            modeLabNewsElement : state => state.lab_news_element.modeLabNewsElement ,
            newsArr : state => state.home.newsArr ,
          }),

          getTextFromHTML:function () {
                return  htmlToText.fromString(this.dataToEdit.descptoin_html, {
                    wordwrap: 80,
                    ignoreImage: true ,
                    ignoreHref: true
                });
          },


 



    },
    methods:{
        ...mapMutations({
            setLabNewsElement : 'lab_news_element/setLabNewsElement',
            setModeLabNewsElement: 'lab_news_element/setModeLabNewsElement'
        }),
      updateNews(){
                this.dataToEdit.descptoin_txt = this.getTextFromHTML
                const  datTo = {
                  "title" :  this.dataToEdit.title,
                  "descptoin_html" :this.dataToEdit.descptoin_html,
                  "descptoin_txt" :  this.dataToEdit.descptoin_txt,
                  "id" : this.dataToEdit.id
                }
                // console.log(JSON.stringify(datTo));
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/updatenews_v2`,datTo,getConfigAxios())
                    .then((res)=>{
                        if(res.status === 200){
                           this.$buefy.toast.open({
                               message: `${res.data.msg}`,
                               type: 'is-success'
                           })
                          
                          // fetch new
                          this.updatedImage() // fake  
                          this.setModeLabNewsElement(0)

                        }
                    })
      },  
      updatedImage(){
            const datTo = {
                "id_news" :   this.labNewsElement.id
            }
            axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
            axios.post(`${getBaseURLforBackEnd()}/api/fetch_specification_news`,datTo,getConfigAxios())
                 .then((res)=>{
                    let tmp =  this.newsArr.find(dat=>dat.id == res.data.id)
                    // console.log('tmp--->',tmp)
                    tmp =  res.data
                    this.setLabNewsElement(tmp)
                 })
      },


 

    },
    data(){
      return {
        isCanAddImage : true,
        customToolbar: [
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    // ["image", "code-block"],
                    [ "code-block"],
                    [{ 'color': [] }, { 'background': [] }],
                ],



        dataToEdit : {}, 
        
        

     
      }
    }
}
</script>



<style>

 

</style>

 